import { UserProfile, } from "./SDKUserProfile";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- -- - --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class User {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b;
        this.id = model.id;
        this.email = model.email;
        this.source = model.source;
        this.profile = new UserProfile(model.profile);
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.linkedIntegrations = (_a = model.linkedIntegrations) !== null && _a !== void 0 ? _a : null;
        this.emailSettings = (_b = model.emailSettings) !== null && _b !== void 0 ? _b : null;
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        var _a;
        return {
            id: this.id,
            email: this.email,
            source: this.source,
            profile: this.profile.toRemote(),
            createdAt: this.createdAt ? this.createdAt.toISOString() : "",
            // @ts-expect-error TS(2322): Type 'LinkedIntegrations | null' is not assignable... Remove this comment to see the full error message
            linkedIntegrations: this.linkedIntegrations,
            emailSettings: (_a = this.emailSettings) !== null && _a !== void 0 ? _a : undefined,
        };
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON, for example for SSR <> Client use-cases. Reconstruct to class instance using `fromTransport` */
    toTransport() {
        var _a;
        return {
            id: this.id,
            email: this.email,
            source: this.source,
            profile: this.profile.toTransport(),
            createdAt: this.createdAt ? this.createdAt.toISOString() : "",
            // @ts-expect-error TS(2322): Type 'LinkedIntegrations | null' is not assignable... Remove this comment to see the full error message
            linkedIntegrations: this.linkedIntegrations,
            emailSettings: (_a = this.emailSettings) !== null && _a !== void 0 ? _a : undefined,
        };
    }
    /** Reconstructs class from the transport model */
    static fromTransport(model) {
        return new User(model);
    }
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Helpers
    /** Returns user's name which should be used in read-only cases. */
    get displayName() {
        return this.profile.name || this.email;
    }
    /** Returns user's initials */
    get initials() {
        var _a, _b;
        const names = this.displayName.split(" ");
        if (names.length === 0) {
            return "";
        }
        let initials = ((_a = names[0]) !== null && _a !== void 0 ? _a : "").substring(0, 1).toUpperCase();
        if (names.length > 1) {
            initials += ((_b = names[names.length - 1]) !== null && _b !== void 0 ? _b : "").substring(0, 1).toUpperCase();
        }
        return initials;
    }
    get firstName() {
        return this.profile.name.split(" ")[0];
    }
}
